<app-public-page-layout>
  <div publicPageAside class="max-w-lg">
    <p
      class="m-0 text-5xl font-extrabold leading-tight tracking-tight text-theme-black xl:text-6xl"
    >
      {{ 'Login.AsideTitle' | translate }}<br />
      <span class="text-theme-600">{{ 'Login.AsideTitleAccent' | translate }}</span>
    </p>
  </div>

  <app-second-factor-step
    *ngIf="secondFactor; else emailOrPassword"
    [challenge]="secondFactor"
    (signedIn)="onVerified()"
    (emailFallback)="onEmailFallback($event)"
    (ended)="onVerificationEnded($event)"
  ></app-second-factor-step>

  <ng-template #emailOrPassword>
    <app-email-verification-step
      *ngIf="verification; else passwordStep"
      [challenge]="verification"
      [linkCode]="linkCode"
      (signedIn)="onVerified()"
      (secondFactor)="onSecondFactorNext($event)"
      (ended)="onVerificationEnded($event)"
    ></app-email-verification-step>
  </ng-template>

  <ng-template #passwordStep>
    <app-tap-alert
      *ngIf="sessionExpired"
      type="info"
      message="Login.SessionExpired"
    ></app-tap-alert>
    <app-tap-alert
      *ngIf="signedOutElsewhere"
      type="info"
      message="Login.SignedOutElsewhere"
    ></app-tap-alert>
    <app-tap-alert *ngIf="codeExpired" type="info" message="Login.CodeExpired"></app-tap-alert>
    <app-tap-alert *ngIf="tooManyCodes" type="info" message="Login.MfaTooManyWrong"></app-tap-alert>
    <app-tap-alert
      *ngIf="finishedFromLink"
      type="info"
      message="Login.FinishedFromLink"
    ></app-tap-alert>

    <h1 class="m-0 text-center text-2xl font-semibold text-theme-600">
      {{ 'Login.Title' | translate }}
    </h1>

    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-1">
      <mat-form-field appearance="outline" class="tl-autofill-field">
        <mat-label>{{ 'Login.Username' | translate }}</mat-label>
        <input matInput id="username" formControlName="userName" autocomplete="username" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="tl-autofill-field">
        <mat-label>{{ 'Login.Password' | translate }}</mat-label>
        <input
          matInput
          id="password"
          formControlName="password"
          autocomplete="current-password"
          [type]="showPassword ? 'text' : 'password'"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="
            (showPassword ? 'CredentialLink.Hide' : 'CredentialLink.Show') | translate
          "
        >
          <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </mat-form-field>
      <button
        type="button"
        class="-mt-2 mb-2.5 cursor-pointer self-end border-0 bg-transparent p-0 text-sm text-theme-600 hover:underline"
        (click)="onForgotPasswordClick()"
      >
        {{ 'Login.ForgotPassword' | translate }}
      </button>

      <button
        mat-flat-button
        color="primary"
        type="submit"
        class="tl-button-icon h-12 w-full"
        [disabled]="isLoggingIn"
        [attr.aria-busy]="isLoggingIn"
      >
        {{ (isLoggingIn ? 'Login.LoggingIn' : 'Login.Login') | translate }}
        <mat-icon *ngIf="!isLoggingIn" aria-hidden="true">arrow_forward</mat-icon>
      </button>
      <p *ngIf="loginError" class="m-0 mt-2 text-sm text-status-red" role="alert">
        {{ loginError | translate: loginErrorParams }}
      </p>
    </form>

    <div
      *ngIf="appStoreLink || googlePlayLink"
      class="mt-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-x-0 border-b-0 border-t border-solid border-pill pt-3.5 text-sm"
    >
      <span class="text-gray-600">{{ 'Login.MobileApp' | translate }}</span>
      <span class="flex gap-4">
        <a
          *ngIf="appStoreLink"
          [href]="appStoreLink"
          target="_blank"
          rel="noopener"
          class="flex items-center gap-1 text-theme-600 no-underline hover:underline"
        >
          {{ 'Login.AppStore' | translate }}
          <mat-icon aria-hidden="true" class="tl-icon-sm">north_east</mat-icon>
        </a>
        <a
          *ngIf="googlePlayLink"
          [href]="googlePlayLink"
          target="_blank"
          rel="noopener"
          class="flex items-center gap-1 text-theme-600 no-underline hover:underline"
        >
          {{ 'Login.GooglePlay' | translate }}
          <mat-icon aria-hidden="true" class="tl-icon-sm">north_east</mat-icon>
        </a>
      </span>
    </div>
  </ng-template>
</app-public-page-layout>
